import React, {useEffect, useState} from 'react';
import {useParams} from 'react-router-dom'
import {saveAddress, finalSubmit} from '../http/service';
import Strings from "../Lang/strings";
import LocationStep from "../components/LocationStep";
import Stepper from "../components/Stepper";
import {INVALID_HOUR, INVALID_LOCATION, steps} from "../utils/constants";
import TimingStep from "../components/TimingStep";
import swal from "../utils/swal";
import useValidateState from "../hooks/useValidateState";
import TrackingStep from "../components/TrackingStep";
import ZainBanner from "../components/ZainBanner";

const CreateOrder = () => {
    const {uuid} = useParams();
    // const history = useHistory();
    let currentLang = Strings.getLanguage();
    const [stepsLang, setStepsLang] = useState(currentLang);
    useEffect(() => {
        setStepsLang(currentLang)
    }, [currentLang]);
    const {
        currentStep,
        setCurrentStep,
        data,
        dataChangeHandler,
        isStateHasFullAddress,
        schedule,
        setSchedule
    } = useValidateState(uuid);

    const handleSubmitDisable = () => {
        switch (currentStep) {
            case 1:
                return !isStateHasFullAddress;
            case 2:
                return false;
            default:
                return true;
        }
    }
    const submitAddress = async () => {
        try {
            const response = await saveAddress(uuid, data.location.latitude, data.location.longitude, data.building, data.street, data.apartment, data.reference_point, data.location_auto_detected);
            window.patch = response.data;

            setSchedule(response.data);
            if (currentStep !== 2 && data.tracking) { // already tracking and he wants to edit location
                setCurrentStep(3);
            } else if (currentStep !== 2) {
                setCurrentStep(2);
            }
        } catch (e) {
            window.e = e;
            if (e.isGeneric) {
                return;
            }
            if (INVALID_LOCATION.includes(e.response.data)) {
                if (currentStep !== 1) {
                    setCurrentStep(1);
                }
                return swal(Strings.locationNotSupported);
            }
            if (e.response.status === 404) {
                if (currentStep !== 1) {
                    setCurrentStep(1);
                }
                return swal(Strings.locationNotSupported);
            }
            if (e.response.status === 422) {
                if (e.response.data.detail === "Locked order") {
                    swal(Strings.lockedOrder);
                    setCurrentStep(3);
                    return;
                }
            }
            swal("something went wrong while submit your location");
        }
    };
    const submitTime = async () => {
        try {
            await finalSubmit(uuid, data.expected_date, data.expected_time,data.location_auto_detected);
            setCurrentStep(3);

        } catch (e) {
            if (e.isGeneric) {
                return;
            }
            if (e.response.status === 404) {
                return swal(Strings.invalidHour, "warning");
            }
            if (e.response?.data?.detail) {
                if (e.response.data.detail === INVALID_HOUR) {
                    return swal(Strings.invalidHour, "warning");
                }
            }
        }


    }
    const onSubmit = () => {
        switch (currentStep) {
            case 1:
                return submitAddress();
            case 2:
                return submitTime();
            default:
                break;
        }
    }
    const subComponents = [
        <div className={"h-screen"}/>,
        <LocationStep data={data} dataChangeHandler={dataChangeHandler}/>,
        <TimingStep schedule={schedule} expectedDate={data.expected_date} expectedTime={data.expected_time}
                    dataChangeHandler={dataChangeHandler} submitAddress={submitAddress}/>,
        <TrackingStep data={data} setCurrentStep={setCurrentStep}/>,
    ];

    const currentSubComponent = subComponents[currentStep];
    return (
        <div className="container m-auto my-4">
            <div className="px-3 md:px-8 lg:px-20">
                <div className={""}>
                    <div className={"lg:mx-3"}>
                        <Stepper currentStep={currentStep} stepsLang={stepsLang} steps={steps}/>
                    </div>
                    <div className={"bg-gray-200 h-30 w-30"}></div>
                    <div className={"mt-10 lg:mt-11"}>
                        {currentSubComponent}
                    </div>
                    <div>
                        {currentStep === 2
                        && <button onClick={() => setCurrentStep(1)}
                                   className={"capitalize text-lg text-gray-700 mx-2 underline my-2"}>{Strings.previous}</button>
                        }

                        {
                            currentStep !== 3 && currentStep !== 0 &&
                            <button
                                disabled={handleSubmitDisable()}
                                onClick={onSubmit}
                                className="talabatey-outline capitalize hover:bg-purple-900 transition  w-full  bg-zain-primary text-white font-bold  py-3.5 rounded"
                                type="button">{Strings.save}</button>
                        }
                    </div>

                </div>
            </div>
        </div>
    );
};

export default CreateOrder;
